export const measureOptions = [
  {
    symbol: 'm²',
    name: 'Metro Cuadrado',
    unit_id: '1',
    factor_to_m2: 1
  },
  {
    symbol: 'ha',
    name: 'Hectáreas',
    unit_id: '2',
    factor_to_m2: 10000
  }
  // SE DESCONOCE SU UTILIZACIÓN
  // {
  //   symbol: 'celemines',
  //   name: 'Celemín',
  //   unit_id: '3',
  //   factor_to_m2: 537
  // }
];

const measureUnitIdBySite = Object.freeze({
  ZPAR: 1,
  IWBR: 1,
  WIBR: 1,
  CMBR: 1,
  ICBR: 1,
  '24MX': 2,
  DVPE: 1,
  LLVE: 1,
  PLEC: 1,
  CAPA: 1,
  VAMX: 2
});

export const defaultMeasureUnitIdBySite = siteId => measureUnitIdBySite[siteId];
